'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = frame;

var _FrameActions = require('./FrameActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    postSuspended: false,
    messages: [],
    reducer: frame
};

function frame() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _FrameActions.SET_POST_SUSPENDED:
            return (0, _extends3.default)({}, state, {
                postSuspended: action.suspended
            });
        case _FrameActions.POST_MESSAGE:
            return (0, _extends3.default)({}, state, {
                messages: [].concat((0, _toConsumableArray3.default)(state.messages), [action.message])
            });
        case _FrameActions.CLEAR_MESSAGES:
            {
                return (0, _extends3.default)({}, state, {
                    messages: []
                });
            }
        default:
            return state;
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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